export const CAPABILITY = {
    AMZL_CORE: "AMZL_CORE",
    AR_NEXT_GEN: "AR_NEXT_GEN"
}

export const HOUR_MILLISECONDS = 3600000;
export const EMPTY_STRING = ""
export const TOTAL_STRING = "Total"
export const TIMEOUT_STRING = "timeout"
export const NEWLINE_CHAR   = "\n"

export const FEATURES = {
    ASL_LEGACY_PROTOCOL: "isASLLegacyProtocol",
    IS_CPT_FILTER_ENABLED: "isCPTFilterEnabled",
    IS_AUTO_FORCE_INDUCT_ENABLED: "isAutoForceInductEnabled"
}

export const ACTION_TYPE = {
    GET_FEATURES_STATUS: "GET_FEATURES_STATUS"
}

export const MARKETPLACE_LOCALE_MAP = {
    de: ["de", "de-DE", "de-CH", "de-AT", "de-LU", "de-LI"],
    es: ["es", "es-ES", "es-AR", "es-GT", "es-CR", "es-PA", "es-DO", "es-MX", "es-VE", "es-CO",
        "es-PE", "es-EC", "es-CL", "es-UY", "es-PY", "es-BO", "es-SV", "es-HN", "es-NI", "es-PR"],
    ja: ["ja", "ja-JP"],
    it: ["it", "it-IT", "it-CH"],
    fr: ["fr", "fr-FR", "fr-BE", "fr-CA", "fr-CH", "fr-LU"],
    ar: ["ar", "ar-SA", "ar-IQ", "ar-EG", "ar-LY", "ar-DZ", "ar-MA", "ar-TN", "ar-OM", "ar-YE",
        "ar-SY", "ar-JO", "ar-LB", "ar-KW", "ar-AE", "ar-BH", "ar-QA"],
    en: ["en"]
}

export const DATE_TIME_FORMAT = {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
    hour:'2-digit',
    minute:'2-digit',
    second:'2-digit',
    timeZoneName: 'short',
    hourCycle:'h23'
}

export const PAGE_HEADERS = {
    INDUCT: {
        tab: "induct.tabHeading",
        tabAlt: "Sort",
        head: "induct.heading",
        headAlt: "Induct",
        desc: "induct.description",
        descAlt: "This page shows the status, cycle, and number of containers and packages in the induct process"
    },
    RECEIVE: {
        tab: "receive.tabHeading",
        tabAlt: "Receive",
        head: "receive.heading",
        headAlt: "Receive",
        desc: "receive.description",
        descAlt: "This table shows the status, cycle, and number of containers and packages in the receive process"
    },
    ASSOCIATE: {
        tab: "dwell.tabHeading",
        tabAlt: "Associates",
        head: "associate.heading",
        headAlt: "Induct associates",
        desc: "associate.description",
        descAlt: "This table shows induct associates’ performance data and current working location"
    },
    INDUCT_MANAGEMENT: {
        tab: "inductmanagement.tabHeading",
        tabAlt: "Sort",
        head: "inductmanagement.heading",
        headAlt: "Induct management",
        desc: "inductmanagement.description",
        descAlt: "This page helps you manage the cycles for induct and force-induct"
    }
}

export const METRIC = {
    GET_MHE_LOCATION_DATA: "getMHELocationData"
}

export const ASL_PREFIX = 'ASL';
export const PACKAGE_SIZE = 'PackageSize';
export const CYCLE = 'Cycle';
export const CLUSTER = 'Cluster';
export const XS = 'XS';
export const S = 'S';
export const M = 'M';
export const L = 'L';
export const XL = 'XL';
export const NC = 'XXL(NC)';
export const VOLUME = 'Volume';
export const FMC = 'FMC';
export const EXTRA_SMALL = 'EXTRA_SMALL';
export const SMALL = 'SMALL';
export const MEDIUM = 'MEDIUM';
export const LARGE = 'LARGE';
export const EXTRA_LARGE = 'EXTRA_LARGE';
export const HEAVY_BULKY_NON_CON = 'HEAVY_BULKY_NON_CON';




// WEBPACK FOOTER //
// ./src/components/util/Constants.js